import React from 'react';
import PropTypes from 'prop-types';

import Link from './Link';

const AuthorCard = ({author, className}) => (
  <div className={className}>
    {author.link ? (
      <Link href={author.link}>
        <AuthorCardContent author={author} />
      </Link>
    ) : (
      <AuthorCardContent author={author} />
    )}
  </div>
);

const AuthorCardContent = ({author}) => (
  <div className="flex">
    {author.image && (
      <img
        className="h-12 w-12 rounded-full object-cover mr-4"
        src={`${author.image}?w=200&h=200`}
        alt={author.name}
        onError={(e) => { e.target.style.display = 'none'; }}
      />
    )}
    <div className="flex flex-col">
      <span className="text-base font-medium whitespace-nowrap text-gray-800">
        {author.name}
      </span>
      {author.title && (
        <span className="text-sm font-medium text-gray-500">
          {author.title}
        </span>
      )}
    </div>
  </div>
);

AuthorCard.propTypes = {
  author: PropTypes.shape({
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    image: PropTypes.string,
    link: PropTypes.string,
  }).isRequired,
};

export default AuthorCard;
